import CurrencyValue from '@/features/finances/components/CurrencyValue';
import { t } from 'i18next';
import React, { FC } from 'react';

type Props = {
	icon: FC<React.SVGProps<SVGSVGElement>> | string;
	label: string;
	value: string | number;
};

const OrderDetailsElement: FC<Props> = ({ icon: Icon, label, value }) => {
	const renderValue = () => {
		if (typeof value === 'number') {
			return <CurrencyValue value={value} asset='other' />;
		}

		if (value.toLowerCase() === 'free') {
			return t('main.orders.components.details.free');
		}

		return value;
	};

	return (
		<div className='py-3 flex items-center gap-2.5 text-sm'>
			{typeof Icon === 'string' ? (
				Icon
			) : (
				<Icon className='stroke-popover-1000' />
			)}
			<span className='shrink-0 truncate'>{label}</span>
			<span className='ml-auto text-right'>{renderValue()}</span>
		</div>
	);
};

export default OrderDetailsElement;
